import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import TopHUD from './TopHUD';
import BottomNav from './BottomNav';
import ToastContainer from '@/components/ui/Toast';
import useGameStore from '@/store/gameStore';
import useNotificationStore from '@/store/notificationStore';
import useAuthStore from '@/store/authStore';
import * as playerService from '@/services/playerService';
import * as friendService from '@/services/friendService';
import * as partnerService from '@/services/partnerService';
import RewardModal from '@/components/modals/RewardModal';
import MissionCompleteModal from '@/components/modals/MissionCompleteModal';
import BadgeUnlockModal from '@/components/modals/BadgeUnlockModal';
import OnboardingOverlay from '@/components/onboarding/OnboardingOverlay';
import UpdatePrompt from '@/components/pwa/UpdatePrompt';
import InstallPrompt from '@/components/pwa/InstallPrompt';

export default function GameLayout() {
  const { rewardModalData, missionCompleteData, badgeUnlockData, closeRewardModal, closeMissionComplete, closeBadgeUnlock } = useGameStore();
  const setUnreadCount = useNotificationStore((state) => state.setUnreadCount);
  const setFriendRequestCount = useNotificationStore((state) => state.setFriendRequestCount);
  const setOfferCount = useNotificationStore((state) => state.setOfferCount);
  const playerCoins = useAuthStore((s) => s.player?.coins ?? 0);

  useEffect(() => {
    let active = true;
    const refreshCounts = () => {
      playerService.getMissions()
      .then((res) => {
        if (!active) return;
        const missions = res.data.data || [];
        setUnreadCount(missions.filter((mission) => mission.status === 'completed').length);
      })
      .catch(() => {});

      friendService.getDashboard()
        .then((res) => {
          if (!active) return;
          setFriendRequestCount((res.data.data?.incoming || []).length);
        })
        .catch(() => {});
    };

    refreshCounts();
    const interval = window.setInterval(refreshCounts, 30000);

    return () => {
      active = false;
      window.clearInterval(interval);
    };
  }, [setFriendRequestCount, setUnreadCount]);

  useEffect(() => {
    let active = true;
    const refreshOffers = () => {
      partnerService.getOffers()
        .then((res) => {
          if (!active) return;
          const now = new Date();
          const count = (res.data.data || []).filter((o) => {
            const expired = o.expiresAt && new Date(o.expiresAt) < now;
            return !expired && o.stock !== 0 && (o.coinCost || 0) <= playerCoins;
          }).length;
          setOfferCount(count);
        })
        .catch(() => {});
    };

    refreshOffers();
    const interval = window.setInterval(refreshOffers, 30000);

    return () => {
      active = false;
      window.clearInterval(interval);
    };
  }, [playerCoins, setOfferCount]);

  return (
    <div className="relative h-full w-full overflow-hidden bg-background">
      <TopHUD />
      <div
        className="overflow-hidden"
        style={{
          position: 'absolute',
          inset: 0,
          top: 'var(--top-hud-height)',
          bottom: 'var(--bottom-nav-height)',
        }}
      >
        <Outlet />
      </div>
      <BottomNav />
      <ToastContainer />

      <RewardModal data={rewardModalData} onClose={closeRewardModal} />
      <MissionCompleteModal data={missionCompleteData} onClose={closeMissionComplete} />
      <BadgeUnlockModal data={badgeUnlockData} onClose={closeBadgeUnlock} />
      <OnboardingOverlay />
      <UpdatePrompt />
      <InstallPrompt />
    </div>
  );
}
